import { Api } from "../../../api/api.js";
import FileSaver from 'file-saver';
import { toast } from "react-toastify";

export const handleDownloadPdf = async (id, type = 'tmp', userType = 'oper', wersja = 1, module = 'rejestr') => {
    const targetURL = 'download-pdf';
    const BASE_URL = `${userType}/${module}/${targetURL}/${id}/${wersja}/${type}`;

    try {
        const response = await Api.get(BASE_URL, { responseType: "blob" });

        if (response.status === 200) {
            const header = response.headers?.['content-disposition'];
            const filename = header?.split(';')
                .find((n) => n.includes('filename='))
                ?.replace('filename=', '')
                ?.replace(/"/g, '')
                ?.trim() || 'downloaded_file.pdf';

            const blob = new Blob([response.data]);
            FileSaver.saveAs(blob, filename);

            toast.success('Plik został pomyślnie pobrany');
        } else {
            toast.error('Błąd podczas pobierania pliku');
        }
    } catch (error) {
        console.error(error);
        toast.error('Wystąpił nieoczekiwany błąd podczas pobierania pliku');
    }
};
